export enum ContractorTeamInfoLabels {
  WorksWith = 'Works With',
  FunctionalLead = 'Functional Lead',
}
export enum PersonaType {
  HireMgrOpenPos = 'HIREMGROPENPOS',
  vendorRepOpenPos = 'VENDORREPOPENPOS',
  OpsTeamOpenPos = 'OPSTEAMOPENPOS',
  HireMgrJobDet = 'HIREMGRJOBDET',
  VendorRepJobDet = 'VENDORREPJOBDET',
  OpsTeamJobDet = 'OPSTEAMJOBDET',
  hiringMgrCandidates = 'HIREMGRCANDIDATE',
  vendorCandidates = 'VENDORCANDIDATE',
  OpsCandidates = 'OPSCANDIDATE',
  ContractorOrgView = 'CONTRACTORORGVIEW',
  SkillsView = 'SKILLSVIEW',
  Timesheet = 'TIMESHEET',
  vendorRepTimesheet = 'VENDORTIMESHEET',
  OpsTimesheet = 'OPSTIMESHEET',
  ContractorTimesheet = 'CONTRACTORTIMESHEET',
  ManagerView = 'ManagerView',
  RtoContractorList = 'RTOCONTRACTORLIST',
  OpsPersona = 'OPSPERSONA',
  BillingHours = 'BILLINGHOURS',
}

export enum ErrorMessages {
  NoEmployeeId = 'No employee ID provided',
  EmployeeNotFound = 'Employee not found',
  InvalidResponse = 'Invalid response from server',
  InternalServerError = 'Internal server error. Please try again later.',
  ConnectionError = 'Unable to connect to server. Please check your connection.',
  ProcessingError = 'Error processing employee data',
  LoadingEmployeeDetails = 'error loading employee details',
  UnableToLoadEmployee = 'Unable to Load Employee Details',
  FailedToLoadEmployee = 'Failed to load employee details',
  UnknownEmployeeName = 'Unknown Employee',
  UnknownRole = 'Unknown Role',
  // Add Exception Error Messages
  InvalidDateRange = 'Please select valid start and end dates',
  InvalidResource = 'Please select a valid resource',
  InvalidEmployeeId = 'Invalid employee ID',
  CommentsRequired = 'Comments are required',
  InvalidDateFormat = 'Invalid date range',
  FillRequiredFields = 'Please fill all required fields',
  SubmissionFailed = 'Failed to add exception. Please try again.',
  NetworkError = 'Network error. Check your connection and try again.',
  InvalidData = 'Invalid data provided. Please check your inputs.',
  Unauthorized = 'You are not authorized to perform this action.',
  AccessDenied = 'Access denied. Please check your permissions.',
  EndpointNotFound = 'API endpoint not found. Please contact support.',
  ServerError = 'Server error. Please try again later.',
  NoDataAvailable = 'No data available',
  ExceptionAddedSuccess = 'Exception added successfully for Employee ID:'
}

export enum NavigationRoutes {
  OpsVendorManagement = '/ops-vendor-management',
  VendorFlowDashboard = '/vendorflow-dashboard',
  VendorProfile = '/ops-vendor-management/vendors-profile/',
  TeamManagement = '/team-management',
  AssetManagement = '/asset-management',
  Finance = '/finance'
}

export enum LoadingMessages {
  LoadingEmployeeDetails = 'Loading employee details...',
}

export enum ButtonLabels {
  TryAgain = 'Try Again',
  GoBack = 'Go Back',
  Refresh = 'refresh',
  ArrowBack = 'arrow_back',
}

export enum EmployeeProfile {
  UnknownEmployee = 'Unknown Employee',
  UnknownRole = 'Unknown Role',
}

export enum Icons {
  Error = 'error',
  Refresh = 'refresh',
  ArrowBack = 'arrow_back',
  Edit = 'edit',
}

export enum Status {
  Open = 'Open',
  ProfileReview = 'Profile Review',
  ProfileShortlisted = 'Profile Shortlisted',
  ProfileRejected = 'Profile Rejected',
  L1Schedule = 'L1 Schedule',
  L2Schedule = 'L2 Schedule',
  L3Schedule = 'L3 Schedule',
  L1Feedback = 'L1 Feedback',
  L2Feedback = 'L2 Feedback',
  L3Feedback = 'L3 Feedback',
  L1Pending = 'L1 Pending',
  L2Pending = 'L2 Pending',
  L3Pending = 'L3 Pending',
  L1Rejected = 'L1 Rejected',
  L2Rejected = 'L2 Rejected',
  L3Rejected = 'L3 Rejected',
  InProgess = 'Onboarding in Progress',
  Hire = 'Good to Hire',
  Joined = 'Joined',
  Rejected = 'Rejected',
  BackedOut = 'Backed Out',
  DroppedOut = 'Candidate Dropped',
  Shortlist = 'Shortlist',
  Selected = 'Initiate Onboarding',
  NoShow = 'No Show of Candidate',
  ReschedulingRequested = 'Re-Scheduling Requested',
  PannelsAvailability = 'Pannel\'s Availability',
  OnHold = 'On Hold',
  Others = 'Others',
}

export enum Roles {
  EMP = 'EMP',
  OPS = 'OPS',
  vendor = 'vendor',
  CWR = 'CWR',
  EMPLOYEE = 'EMPLOYEE', // Regular CBRE employees (non-leaders) — iSkill only
  UNKNOWN = 'null',
  IOP = 'IOP', // IOP hardcoded email id's have access to all the routes
}

export enum StatusClass {
  Profile = 'status-shortlist',
  Pending = 'status-Pending',
  Dropped = 'status-dropped',
  Selected = 'status-selected',
  Shortlist = 'status-shortlist',
}

export enum RoutePaths {
  HireMgr = 'hiring-manager',
  VendorMgmt = 'vendor-management',
  VendorRep = 'vendor',
  OpsTeam = 'ops',
  OpsVendorManagement = 'ops-vendor-management',
  TeamManagement = 'team-management',
  AssetManagement = 'asset-management',
  VendorEmployee = 'vendor-employee',
  ISkill = 'iskill',
  Finance = 'finance',
  Adoption = 'adoption',
  Productivity = 'productivity',
}

export enum JobDetErrorMsg {
  ErrorMessage = 'No Candidates Available',
  errorVendorMessage = 'No Navigation Available',
}

export enum ButtonLabel {
  View = 'View',
  Update = 'Update',
  Deactivate = 'Deactivate',
}

export enum ButtonIcon {
  Edit = 'edit',
  Visibility = 'visibility',
}

export enum TabLabels {
  OpenPositions = 'Open positions',
  Candidates = 'Candidates',
}

export enum ButtonSelection {
  Primary = 'Primary',
  Secondary = 'Secondary',
}

export enum Priority {
  red = 'red',
  green = 'green',
  flag = 'flag',
  check = 'check',
  Critical = 'Critical',
  Standard = 'Standard',
  grey = '#767676',
  black = 'black',
  iconGreen = '#50af78',
  lightOrange = '#d2785a',
  lightBlue = '#8585e0',
  lightred = '#FF543E',
  darkred = '#A03530',
  amber = '#FF9742',
  darkGreen = '#195545',
  pendingSubmission = '#D16F0B',
  pendingApproval = '#8B4D0B',
  timesheetApproved = '#469566',
  timesheetRejected = '#D03B2D',
}

export enum ChartDefaults {
  MONTHS_TO_SHOW = 12,
  DROPDOWN_FIRST_INDEX = 0,
}

export enum SkillType {
  PrimarySkill = 'primarySkill',
  SecondarySkill = 'secondarySkill',
  Submission = 'submission',
  Pending = 'pending',
}

export enum MonthsEnum {
  January = 'January, 2024',
  February = 'February, 2024',
  March = 'March, 2024',
  April = 'April, 2024',
  May = 'May, 2024',
  June = 'June, 2024',
  July = 'July, 2024',
  August = 'August, 2024',
  September = 'September, 2024',
  October = 'October, 2024',
  November = 'November, 2024',
  December = 'December, 2024',
}

export enum NotificationTitlesEnum {
  TimesheetRejected = 'Timesheet Rejected',
  ContractorRelease = 'Contractor Release',
}

export const NotificationDetails = {
  [NotificationTitlesEnum.TimesheetRejected]: {
    message: 'Timesheet of Ramesh is rejected',
    time: '11:55 AM, 24/02/2025',
    action: 'View',
  },
  [NotificationTitlesEnum.ContractorRelease]: {
    message: 'Contractor "Raghu" will be released on 20/03/2025',
    time: '11:55 AM, 24/02/2025',
    action: 'Notify',
  },
};
export enum RoutesEnum {
  VendorManagement = 'vendor-management',
  OpsVendorManagement = 'ops-vendor-management',
  vendorFlowRoute = 'vendorflow-dashboard',
  VendorProfile = 'vendor-profile',
  Vendor = '/vendor',
  OpenPositionsBreadcrumb = 'Vendor Management / Open Positions',
  RaiseHiringRequestBreadcrumb = 'Vendor Management / Raise Hiring Request',
  OpsVendorsList = 'Vendor Management / Vendors List',
  feedbackForm = 'Vendor Management / Quarterly Feedback Form',
  quarterlyFeedback = 'quarterly-feedback',
  OpsVendorProfile = 'vendors-profile',
  Login = 'login',
  LoginCallback = 'login/callback',
  ContractorProfile = '/vendorflow-dashboard/contractor-profile',
  opsContractorProfile = '/ops-vendor-management/contractor-profile',
  dashboard = 'Dashboard',
  teamManagement = 'Team Management',
  assetManagement = 'Asset Management',
  teamComposition = 'Team Composition',
  teamCompositionDetails = 'team-composition-details',
  vendorsList = 'vendors-list',
  asset = 'asset-management',
  stats = 'vendor-stats'
}
export enum DropdownOptions {
  OpenPositions = 'open-positions',
  RaiseHiringRequest = 'raise-hiring-request',
}

export function getNoDataMessage(context: string): string {
  const messages: { [key: string]: string } = {
    upcomingInterviews: 'No Upcoming Interviews Found',
    default: 'No Data Available',
    alt: 'No records illustration',
  };

  return messages[context] || messages['default'];
}

export enum HeaderText {
  INTERVIEW_STATUS = 'Interview Status',
  ADD_VENDOR = 'Add Vendor',
  VENDORS_TIMESHEET = "Vendor's Timesheet",
  VENDORS_LIST = "Vendor's List",
  LeaveSummary = 'Leave Summary',
  RTO_Calendar = 'RTO Calendar',
  BillingDate = 'Calculate Billing Hours',
  OrganisationDetails = 'Organisation Details',
  UploadDocuments = 'Upload Documents',
  BusinessAndBankDetails = 'Business and Bank Details',
  AuthorisedSignatoryInformation = 'Authorised Signatory Information',
  ContactInformation = 'Contact Information',
  ModifyVendorInformation = 'Modify Vendor Information',
  ModifyContactInformation = 'Modify Contact Information',
}

export enum ContractorListEnum {
  Breadcrumb = 'Vendor Management / Contractor List',
  SearchLabel = 'Search',
  FilterLabel = 'Filter',
  NoRecordsTitle = 'No records found',
  NoRecordsAltText = 'No records illustration',
  ListOfContractors = 'List of Contractors',
  Success = 'SUCCESS',
  Failed = 'FAILED',
  Month = 'month',
  VendorName = 'vendorName',
  vendorContractorBreadcrumb = 'Vendor Management / Contractor Profile page',
}

export enum VendorListEnum {
  Breadcrumb = 'Vendor Management / List of Vendors',
  vendorProfile = 'Vendor Profile',
  vendorList = 'Vendors List',
  SearchLabel = 'Search',
  FilterLabel = 'Filter',
  NoRecordsTitle = 'No records found',
  NoRecordsAltText = 'No records illustration',
  ListOfVendors = 'List of Vendors',
  onBoardered = 'onboarded',
  updateRequests = 'updateRequests',
}

export enum TimesheetEnum {
  Breadcrumb = 'Vendor Management / Timesheet',
  TimeSheet = 'Timesheets',
  Approved = 'Approved',
  Rejected = 'Rejected',
  PendingApproval = 'Pending Approval',
  PendingSubmission = 'Pending Submission',
}

export enum ApiStatus {
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
  ERROR = 'ERROR',
  FailedStatus = 'Failed to update status',
  UpdatedStatus = 'Request Status has been Updated!',
}

export enum ToastTitle {
  SUCCESS = 'Success',
  ERROR = 'Error',
  INFO = 'Information',
  WARNING = 'Warning',
}

export enum HttpStatusCode {
  OK = 200,
  CREATED = 201,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  NOT_FOUND = 404,
  INTERNAL_SERVER_ERROR = 500,
}

export enum LocationEnum {
  Hyderabad = 'Hyderabad',
  Noida = 'Noida',
  Gurgaon = 'Gurgaon',
  Remote = 'Remote',
}

export enum DefaultValues {
  Unknown = 'Unknown',
  NotAvailable = 'N/A',
}

export enum VendorManagementEnum {
  VendorManagement = 'Vendor Management / ',
  OpenPositions = 'Open Positions',
  Candidates = 'Candidates',
}

export enum ContractorHeadCountError {
  FETCH_ERROR = 'Error fetching contractor head count. Please try again later.',
  THROW_ERROR = 'Failed to fetch contractor head count. Please try again later.',
}

export enum TimesheetStatus {
  Approved = 'Approved',
  Rejected = 'Rejected',
  NotApplicable = 'Not Applicable',
  PendingApproval = 'Pending Approval',
  PendingSubmission = 'Pending Submission',
}

export enum PageTitle {
  VendorManagement = 'Vendor Management',
  OnboardVendor = 'Onboard New Vendor',
  ContractorList = 'Contractor List',
  VendorsList = 'Vendors List',
  UpcomingInterviews = 'Upcoming Interviews',
  TopVendors = 'Top Vendors',
  ListOfVendors = 'List of Vendors',
  ContractorHeadcount = 'Contractor Headcount',
  OPSAccessManagement = 'Vendor Management / Access Management',
  TeamManagement = 'Team Management',
  AssetManagement = 'Asset Management', 
  TeamComposition = 'Team Composition',
  Employee360 = 'Employee 360° View',
  TeamDashboard = 'Team Dashboard',
}

export enum RtoTypeEnum {
  Regular = 'Regular',
  Hybrid = 'Hybrid',
  PartialHybrid = 'Partial Hybrid',
  Remote = 'Remote',
}

export enum EmeraldLabel {
  Search = 'Search',
  Month = 'Month',
}

export enum ContractorHeadCountLabels {
  Total = 'Total',
  OnBoarded = 'On-boarded',
  OffBoarded = 'Off-boarded',
  Contractors = 'Contractors',
  ContractorHeadcount = 'Contractor Headcount',
}

export enum MsaExpiringEnum {
  Title = 'Expiring MSA',
  msaExpiry = 'No Records Found',
  default = 'No Data Available',
  alt = 'No records illustration',
}

export enum PositionLabels {
  Title = 'Positions',
  Total_Positions = 'Total',
  Open_Positions = 'Open ',
  On_Hold_Positions = 'On-Hold ',
  Closed_Positions = 'Closed ',
}

export enum LeaveTypeEnum {
  Paid = 'paid',
  Unpaid = 'unpaid',
  Public = 'public',
  PublicHoliday = 'public-holiday',
  HalfPaid = 'halfpaid',
  HalfUnpaid = 'halfunpaid',
}

export enum rtoTypeEnum {
  Office_days = 'office',
  Remote_days = 'remote',
  Absent_days = 'absent',
  Holiday_days = 'holiday',
}

export enum quarterlyFeedback {
  fileLabel = 'Select file(s) or drop here to upload',
  fileType = 'Excel format only, up to 3 MB.',
  feedbackHeading = 'Quarterly Feedback Form',
  feedbackTitle = 'Compliance',
  validationError = 'Please upload the file',
  fileExceedsSize = 'File size exceeds the maximum allowed size of 3MB.',
  invalidType = 'Invalid file type. Please upload a Excel document.',
  msaRateCardCompliance = 'MSA and Rate card compliance*',
  assetCompliance = 'Asset compliance*',
  sowCompliance = 'SOW compliance*',
  invoiceCompliance = 'Invoice compliance*',
  assetUpload = 'Asset Upload',
  msaUpload = 'MSA Upload',
  sowUpload = 'SOW Upload',
  invoiceUpload = 'Invoice Upload',
  personIcon = 'person',
  browseFile = 'Browse File',
  successMsg = 'Quarterly Feedback Form submitted successfully',
  errorMsg = 'Failed to submit quarterly feedback. Please try again later.',
  learningDevelopmentFormatMessage = 'Please fill the learning and Development data in the attached format',
  // New fields
  openPositions = 'Opened Positions*',
  nicheSkills = 'Niche Skills*',
  fullTimeConversions = 'No of full-time conversions this year*',
  bufferResources = 'Buffer Resources*',
  supportingDocuments = 'Supporting Documents*',
  investmentPrograms = 'Investment for strategic programs*',
  coinnovatedIdeas = 'No of use case/ideas co-innovated*',
  investmentDocuments = 'Investment Documents*',
  coinnovationDocuments = 'Co-innovation Documents*',
  learningDocuments = 'Learning Documents*',
  peopleMetrics = 'People Metrics',
  strategicPartnership = 'Strategic Partnership',
  learningDevelopment = 'Learning & Development',
  learningUploadSuccess = 'Learning document uploaded successfully',
  learningUploadError = 'Failed to upload learning document',
  uploadFailedGeneric = 'Failed to upload document',
  quarterlyFeedbackText = 'Quarterly Feedback',
  noVendorId = 'No vendor ID available',
  vendorFetchError = 'Error fetching vendor details',
  vendorDataFetchError = 'Failed to fetch vendor data',
  navigationFailed = 'Navigation failed. Please try again.',
  navigationError = 'Error during navigation: ',

  vendorCandidates = 'VENDORCANDIDATE',
  OpsCandidates = 'OPSCANDIDATE',
  ContractorOrgView = 'CONTRACTORORGVIEW',
  Timesheet = 'TIMESHEET',
  vendorRepTimesheet = 'VENDORTIMESHEET',
  ManagerView = 'ManagerView',
  feedbackform = '/ops-vendor-management/quarterly-feedback/',
  releaseForm = 'Release details submitted successfully',
  releaseErrorMsg = 'Failed to submit release details',
  myProfile = 'My Profile',
  assetFileType = 'JPEG, PNG and PDF up to 50 MB.'
}

export enum peopleMetricsLabels {
  skills = 'Skills Distribution',
  metrics = 'Metrics',
}

export enum VendorsDropdownOptions {
  'Onboard Vendor' = 'onboard-vendor',
  'Show All Vendors' = 'all-vendors',
  'Quarterly Feedback Form' = 'quarterly-feedback',
  'Admin Screen' = 'access-control',
}

export enum releaseInfo {
  releaseType = 'Release Type:',
  releaseDate = 'Release Date:',
  comments = 'Comments',
  submittedby = 'Submitted By:',
  submittedOn = 'Submitted On:',
  header = 'Release Details',
  dateValidation = 'Release date cannot be in the past.',
  errorMessage = 'Invalid date format.',
}

/**
 * Bucketed Performance Rating captured on the new quarterly-feedback form.
 * Values are level integers 1..5 (stored on the DB as LEVEL_1 .. LEVEL_5
 * because a Java enum identifier can't start with a digit), plus TOO_NEW
 * and N_A for the two "no rating" states.
 *
 * Historical rows from the earlier A/B/C/D bucket scale have been migrated
 * one-off (A→LEVEL_4, B→LEVEL_3, C→LEVEL_2, D→LEVEL_1); the legacy 5-star
 * technical/behavioural columns are unchanged and still render for pre-
 * performance-rating history.
 */
export enum PerformanceRating {
  LEVEL_1 = '1',
  LEVEL_2 = '2',
  LEVEL_3 = '3',
  LEVEL_4 = '4',
  LEVEL_5 = '5',
  TOO_NEW = 'TOO_NEW',
  N_A = 'N_A',
}

export interface PerformanceRatingOption {
  value: PerformanceRating;
  label: string;
  description: string;
}

/**
 * Header label for a feedback quarter box. Q2 / Q4 read as their business
 * milestone name ("Mid Year Review" / "Year End Review") since managers
 * think about those quarters as review cycles, not just calendar buckets.
 * Q1 / Q3 keep the plain "Quarter Qn YYYY" form.
 */
export function formatQuarterBoxLabel(quarter: number | string, year: number): string {
  const q = typeof quarter === 'number'
    ? quarter
    : Number.parseInt(String(quarter).replace(/^Q/i, ''), 10);
  if (q === 2) return `Mid Year Review ${year}`;
  if (q === 4) return `Year End Review ${year}`;
  return `Quarter Q${q} ${year}`;
}

export const PERFORMANCE_RATING_OPTIONS: readonly PerformanceRatingOption[] = [
  { value: PerformanceRating.LEVEL_5, label: '5 - Exceptional',                     description: 'Far exceeds all goals; sets a standard of excellence for others.' },
  { value: PerformanceRating.LEVEL_4, label: '4 - Exceeds Expectations',            description: 'Consistently goes above and beyond core role requirements.' },
  { value: PerformanceRating.LEVEL_3, label: '3 - Meets Expectations',              description: 'Fully satisfies all position requirements and performance goals.' },
  { value: PerformanceRating.LEVEL_2, label: '2 - Partially Meets Expectations',    description: 'Meets some goals but requires coaching/improvement in key areas.' },
  { value: PerformanceRating.LEVEL_1, label: '1 - Does Not Meet Expectations',      description: 'Consistently falls short of essential job standards; immediate action needed.' },
  { value: PerformanceRating.TOO_NEW, label: 'NA - Too New to Rate',                description: '< 90 days tenure' },
  { value: PerformanceRating.N_A,     label: 'NA - Not Applicable',                 description: 'Non-billable / Other' },
] as const;

/** Compact display label used in list/tile surfaces (e.g. "5", "NA"). */
export const PERFORMANCE_RATING_SHORT_LABEL: Readonly<Record<PerformanceRating, string>> = {
  [PerformanceRating.LEVEL_1]: '1',
  [PerformanceRating.LEVEL_2]: '2',
  [PerformanceRating.LEVEL_3]: '3',
  [PerformanceRating.LEVEL_4]: '4',
  [PerformanceRating.LEVEL_5]: '5',
  [PerformanceRating.TOO_NEW]: 'NA',
  [PerformanceRating.N_A]:     'NA',
};

/** Grid-friendly display: "5 - Exceptional", "NA - Too New to Rate", etc.
 *  Used by table cells and historical feedback pills. */
export const PERFORMANCE_RATING_GRID_LABEL: Readonly<Record<PerformanceRating, string>> = {
  [PerformanceRating.LEVEL_1]: '1 - Does Not Meet Expectations',
  [PerformanceRating.LEVEL_2]: '2 - Partially Meets Expectations',
  [PerformanceRating.LEVEL_3]: '3 - Meets Expectations',
  [PerformanceRating.LEVEL_4]: '4 - Exceeds Expectations',
  [PerformanceRating.LEVEL_5]: '5 - Exceptional',
  [PerformanceRating.TOO_NEW]: 'NA - Too New to Rate',
  [PerformanceRating.N_A]:     'NA - Not Applicable',
};

export enum contractorQuarterlyFeedback {
  NoFeedback = 'No Feedback Available',
  Feedback = 'Quarterly Feedback',
  email = 'Vinay.Mohadikar@cbre.com',
  Technical = 'Technical Rating',
  Behavioural = 'Behavioural Rating',
  PerformanceLabel = 'Performance Rating',
  PerformanceError = 'Please select a performance rating.',
  date = '7th July 2025',
  Breadcrumb = 'Vendor Management',
  ContractorList = 'Contractor List',
  Profile = 'Contractor Profile',
  About = 'About',
  TeamInfo = 'Team Info',
  Performance = 'Reward History',
  ISkills = 'ISkill',
  BehaviouralError = 'Please select at least one behavioural rating.',
  TechnicalError = 'Please select at least one technical rating.',
  CommentError = 'Please enter feedback comments.',
  RatingError = 'Please select at least one',
  Rating = 'Rating',
  ContactorName = 'Raghavan',
  ContractorProfile = 'Sr UX Designer',
  Update = 'Update',
  Submit = 'Submit',
  Current = 'Current',
  AddFeedback = 'AddFeedback',
  CommentPlaceholder = 'CommentPlaceholder',
}

export namespace contractorQuarterlyFeedbackUtils {
  export function getModalTitle(section: string): string {
    switch (section) {
      case 'About':
        return contractorQuarterlyFeedback.About
          ? `Edit ${contractorQuarterlyFeedback.About} Information`
          : 'Edit About Information';
      case 'TeamInfo':
        return contractorQuarterlyFeedback.TeamInfo
          ? `Edit ${contractorQuarterlyFeedback.TeamInfo}`
          : 'Edit Team Info';
      case 'Performance':
        return contractorQuarterlyFeedback.Performance
          ? `Edit ${contractorQuarterlyFeedback.Performance}`
          : 'Edit Performance';
      case 'ISkills':
        return contractorQuarterlyFeedback.ISkills
          ? `Edit ${contractorQuarterlyFeedback.ISkills}`
          : 'Edit Skills';
      default:
        return 'Edit Information';
    }
  }
}

export enum JobStatusEnum {
  OnHold = 'Onhold',
  Closed = 'Closed',
  Open = 'Open',
}

export enum TabType {
  VENDOR = 'vendor',
  LEADERS = 'leaders',
}

export enum VendorStatus {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
}

export enum vendorStatus {
  Active = 'active',
  Inactive = 'inactive',
}

export enum SortDirection {
  ASC = 'asc',
  DESC = 'desc',
}

export enum TimesheetMessages {
  SelectToApprove = 'Please select at least one timesheet to approve',
  SelectToReject = 'Please select at least one timesheet to reject',
  ApproveSuccess = 'Selected timesheets approved successfully',
  RejectSuccess = 'Selected timesheets rejected successfully',
  Warning = 'Warning',
  Success = 'Success',
  Error = 'Error',
}

export enum PageTitles {
  ACCESS_MANAGEMENT = 'Access Management',
}

export enum RTODrill {
  VendorManagement = 'Vendor Management',
  VendorList = 'Vendor List',
  ContractorList = 'Contractor List',
  ListofContactors = 'List of Contractors',
  NoRecords = 'No records illustration',
  URLError = 'Invalid vendor ID or type.',
  vendor = '/vendor-management',
  list = '/vendor-management/vendors-list',
}

export enum EmeraldButtonSize {
  SMALL = 'Small',
  MEDIUM = 'Medium',
  LARGE = 'Large',
}

export enum EmeraldButtonVariant {
  PRIMARY = 'Primary',
  SECONDARY = 'Secondary',
  TEXT_BUTTON = 'TextButton',
  LIGHT = 'Light',
  CUSTOM = 'Custom',
}

export enum EmeraldButtonAlignment {
  LEFT = 'Left',
  RIGHT = 'Right',
}

export interface CalendarDay {
  day: number;
  fullDate: Date;
  isCurrentMonth: boolean;
  isToday: boolean;
  isWeekend: boolean;
  attendanceType: string | null;
  tooltip: string;
}

export enum VendorProfile {
  vendorProfile = 'Vendor Profile',
  contractorHeadCount = 'Contractors Onboarded',
  interviewStatus = 'Interview Status',
  vendorInfo = 'Vendor Info',
  quarterlyFeedback = 'Quarterly Feedback',
  rtoCompliance = 'RTO Compliance',
  generalCompliance = 'General Compliance',
  strategicPartnership = 'Strategic Partnership',
  failedToLoad = 'Failed to load interview status data',
  failedToLoadContractorHeadCount = 'Failed to load Contractors Onboarded data',
  invalidMonthSelected = 'Invalid month selected',
  vendorIdMissing = 'Vendor ID is missing',
  vendorNameMissing = 'Vendor name is missing',
  invalidQuarterId = 'Invalid quarter ID provided',
  strategicPartnershipNotFound = 'Strategic partnership data not found',
  vendorProfileUpdationSuccess = 'Vendor profile updated successfully',
  vendorProfileUpdationError = 'Failed to update vendor profile.',
  partnershipPrograms = 'Partnership programs',
}

export enum InterviewStatus {
  positionsOpened = 'Positions Opened',
  profilesSubmitted = 'Profiles Submitted',
  onBoardingPending = 'Onboarding in Progress',
  inProgress = 'In Progress',
}

export enum InterviewStatusWidget {
  InterviewsStatus = 'Interviews Status',
  Profiles = 'Profiles',
  Pending = 'Pending',
  Rejected = 'Rejected',
  orange = '#F2994A',
  red = '#B3261E',
  Error = 'Error fetching candidates data',
}

export enum ProfileStatusLabels {
  Open = 'Open',
  OnboardingInProgress = 'Onboarding In Progress',
  Joined = 'Joined',
  Dropped = 'Dropped',
  ProfilesIn = 'Profiles in',
}

export const chartColors = {
  backgroundWhite: '#ffffff',
  textDark: '#1a1a1a',
  mintGreen: '#80bbad',
  darkOrange: '#ff543e',
  dividerGrey: '#e0e0e0',
  tooltipBackground: '#ffffff',
  tooltipTitle: '#000000',
  tooltipBody: '#000000',
  rtoRed: '#dc2626',
  rtoLightRed: '#d97706',
  rtoLightGreen: '#2563eb',
  rtoDarkGreen: '#003f2d',
};

export const RtoBarChartConstants = {
  legendPosition: 'bottom',
  legendFontSize: 14,
  toolTipBorderWidth: 1,
  dataLabelFontSize: 12,
  dataLabelAnchor: 'center',
  dataLabelAlign: 'center',
  xBarThickness: 78.086,
  tickFontSize: 9,
  tickAlign: 'center',
  yTickStepSize: 2,
  barChartLabelCompliant: 'Compliant',
  barChartLabelNonCompliant: 'Non-Compliant',
};

export const vendorProfileMetrics = {
  TotalContractors: 'Total Contractors',
  HyderabadContractors: 'Hyderabad',
  NcrContractors: 'NCR',
  RemoteContractors: 'Remote',
  compliance: 'Compliance',
  peopleMetrics: 'People Metrics',
  learningDevelopment: 'Learning & Development',
  strategicPartnership: 'Strategic Partnership',
};

export const strategicPartnership = {
  InvestmentsForStrategicPrograms: 'Investments for Strategic Programs',
  NoOfUseCasesCoInvented: 'No. of Use Cases/Ideas Co-Invented',
};

export const vendorProfileInfo = {
  labelAbout: 'About',
  labelVendorPSID: 'Vendor PSID',
  labelFullAddress: 'Full Address',
  labelEmailID: 'Email ID',
  labelDateOfOnboarding: 'Date of Onboarding',
  labelMSAExpiryDate: 'MSA Expiry Date',
  labelC2H: 'C2H',
  labelReleaseTimeline: 'Release Timeline',
  labelPointOfContact: 'Point of Contact',
  labelDesignation: 'Designation',
  labelEmail: 'Email',
  labelMobileNumber: 'Mobile Number',
  labelLocation: 'Location',
  keyVendorId: 'vendorId',
  keyFullAddress: 'fullAddress',
  keyEmailVendor: 'emailVendor',
  keyDateOfOnboarding: 'dateOfOnboarding',
  keyMsaexpiryDate: 'msaexpiryDate',
  keyC2H: 'c2h',
  keyReleaseTimeline: 'releaseTimeline',
  keyPointOfContact: 'pointOfContact',
  keyDesignation: 'designation',
  keyEmail: 'email',
  keyMobileNumber: 'contact',
  keyLocation: 'location',
  vendorIdMissing: 'Vendor ID is missing',
  vendorInformationUnavailable: 'Vendor information is unavailable',
};

export const TIMESHEET_LABELS = {
  search: 'Search',
  status: 'Status',
  month: 'Month',
  noRecordsIllustration: 'No records illustration',
  getCalendar: 'Get Calendar',
  opsTimesheet: 'OpsTimesheet',
};

export enum GeneralComplianceLabels {
  MSA_RATE_CARD_EXCEPTIONS = 'MSA Rate Card Exceptions',
  SOW_COMPLIANCE = 'SoW Compliance',
  INVOICE_COMPLIANCE = 'Invoice Compliance',
  ASSET_COMPLIANCE = 'Asset Compliance',
  ONBOARD_ASSET_COMPLIANCE = 'On Board Asset Compliance',
  OFFBOARD_ASSET_COMPLIANCE = 'Off Board Asset Compliance',
}

export enum ContractorProfileEnum {
  NoRecordsIllustration = 'No records illustration',
  NoEmployeeFound = 'No Employee Found',
}

export enum OpsVendorListEnum {
  ServiceError = 'Failed to fetch onboarded vendors',
  Error = 'Error fetching onboarded vendors data',
}

export enum TimeCompositionListEnum {
  SEARCH = 'Search',
  NO_RECORDS_FOUND = 'No Records Found',
  LOCATION = 'Filter by Location',
  RESOURCE_TYPE = 'Filter by Employment Type',
  HEADER_TEXT = 'Team Composition',
  NO_DATA_FOUND = 'No Data Found',
  VIEW_ADD_FEEDBACK = 'View / Add Feedback',
  EXCLUDE_FROM_ISKILL = 'Exclude from iSkill',
  INCLUDE_IN_ISKILL = 'Include in iSkill',
  MARK_INACTIVE = 'Mark Inactive',
  EXCLUDE_TITLE = 'Exclude from iSkill',
  INCLUDE_TITLE = 'Include in iSkill',
  MARK_INACTIVE_TITLE = 'Mark as Inactive',
  EXCLUDED_SUCCESS = 'excluded from iSkill.',
  INCLUDED_SUCCESS = 'included in iSkill.',
  INACTIVE_SUCCESS = 'marked as Inactive.',
  ACTION_FAILED = 'Unable to complete the action. Please try again.',
  LAST_WORKING_DAY = 'Last working day',
}
export enum RtoDetailsCSS {
  statusRegular = 'status-regular',
  statusRemote = 'status-remote',
  statusHybrid = 'status-hybrid',
  statusPartialHybrid = 'status-partial-hybrid',
}

export enum RtoCard {
  rtoTitle = 'RTO',
  noDataAvailable = 'No Data Available',
  employeeIdMissing = 'Employee ID not available',
  rtoDataFetchFailed = 'RTO data fetch failed',
  remote = 'Remote',
  partialHybrid = 'Partial Hybrid',
  hybrid = 'Hybrid',
  regular = 'Regular',
}

export enum TeamCards {
  errorMessage = 'Error fetching team cards data',
  myTeam = 'My Team',
  employeeType = 'Employee Type',
  teamDemographics = 'Team Demographics',
  quickLinks = 'Quick Links',
  quickLinksText = 'Click here for quick access to Manager Help links',
  teamSize = 'Team Size',
  directReportees = 'Direct Reportees',
  fullTime = 'Full Time',
  contractors = 'Contractors',
  iconColor = '#003F2D',
  diversityInfo = 'Gender Diversity is coming soon',
}

export enum RtoDetailsEnum {
  errorMessage = 'Error fetching RTO details data',
}

export enum AddException {
  modalTitle = 'Add Exception',
  commentsText = 'Comments',
  helpText = 'Note: Please specify the dates and reason for exception',
  cancelLabel = 'Cancel',
  submitLabel = 'Submit',
  cancelType = 'Secondary',
  submitType = 'Primary',
  resourceLabel = 'Resource',
}

export enum Dropdown {
  month = 'Month',
  location = 'Location',
  selectMonth = 'Select Month'
}

export enum VendorStatsCardEnum {
  vendorStatsCardTitle = 'Vendor Stats',
  noDataAvailable = 'No Data Available',
  vendorStatsDataFetchFailed = 'Failed to fetch vendor stats data.',
  vendorSummaryDataFetchFailed = 'Failed to fetch vendor summary data.',
  vendorStatsLoadError = 'Error loading vendor stats data.',
  vendorSummaryLoadError = 'Error loading vendor summary data.',
  selectMonth = 'Select Month',
  vendor = 'Vendor',
  totalHeadCount = 'Total HeadCount',
}

export enum DamageAnalyticsCardEnum {
  damageAnalyticsCardTitle = 'Damage Analytics',
  noDataAvailable = 'No Data Available',
  damageAnalyticsDataFetchFailed = 'Failed to fetch damage analytics data.',
  damageAnalyticsLoadError = 'Error loading damage analytics data.',
  selectMonth = 'Select Month',
  fileType = 'JPEG, PNG and PDF up to 50 MB.'
}

export enum BreadcrumbLabels {
  VendorManagement = 'Vendor Management',
  VendorsList = 'Vendors List',
  VendorProfile = 'Vendor Profile',
  AssetManagement = 'Asset Management',
  VendorStats = 'Vendor Stats',
}


export enum VendorEmployeeEnum {
  successLeave = 'Leave application submitted successfully!',
  errorLeave = 'Failed to submit leave application. Please try again.',
  validationError = 'Please fill in all required fields correctly.',
  fileError = 'Only PDF, PNG, and JPEG files are allowed.',
  fileSizeError = 'File size cannot exceed 3 MB.',
  uploadLeaveAttachmentError = 'Failed to upload leave attachment.',
  leaveTypeSelection = "Please select a leave type.",
  noLeaveSelected = "Number of leaves cannot be zero or you selected weekends/public holidays only. Please adjust your selection.",
  timesheetValidationError = "Error validating timesheet status. Please try again.",
  cancelLeave = "Leave application cancelled successfully.",
}